import React from 'react'
import { getIcons } from '../../Constant/Constant'

const NotFound = ({title}) => {
    const icons = getIcons()
  return (
    <div className='w-full  flex justify-center items-center'>
      <div className='flex flex-col items-center'>
      <img src={icons?.notFound} alt="404" className='w-80 h-80' />
      <div className='text-xl text-slate-400 font-semibold'>{title}</div>
      </div>
       
      
    </div>
  )
}

export default NotFound
